import { Fragment } from 'react'
import { UrlRegex } from 'lib/string'
import { useMemo } from 'react'
import { ExternalLink } from './ExternalLink'

type Props = {
  children: string
}

export const TextWithLink = ({ children = '' }: Props) => {
  const render = useMemo(() => {
    const breakedLine = children.split(/\n/)
    const breakedText = breakedLine.map((line) =>
      line.split(/\s/).filter((t) => t.length)
    )

    const result = breakedText.map((line, lineIndex) => {
      const lineResult = line.map((text, index) => (
        <Fragment key={`${lineIndex}-${index}`}>
          {index > 0 && ' '}
          {text.match(UrlRegex) ? (
            <ExternalLink href={`//${text.replace(/https?:/, '')}`}>
              {text}
            </ExternalLink>
          ) : (
            text
          )}
        </Fragment>
      ))

      if (lineIndex)
        lineResult.unshift(<Fragment key={`${lineIndex}-n`}>{'\n'}</Fragment>)

      return lineResult
    })

    return <>{result}</>
  }, [children])

  return render
}
